import React from "react";
import PropTypes from 'prop-types';
import AddIcon from "@material-ui/icons/Add";
import { Fab, Tooltip } from "@material-ui/core";

export default function Add(props) {

    return (
        <Tooltip title={<span style={{ fontSize: 15 }}>Inserir</span>}>
            <Fab
                style={{ margin: 10 }}
                color="primary"
                aria-label="add"
                onClick={() => {
                    props.setOpen(true);
                    props.setData(null);
                }}
            >
                <AddIcon />
            </Fab>
        </Tooltip>
    );
}

Add.propTypes = {
    setData: PropTypes.func,
    setOpen: PropTypes.func,
};
